import { useEffect } from "react"
import { IAdditionalServiceModel } from "./ReservationModel"

interface Props {
  formik: any
  setSelectedServicesTotal: (total: number) => void
}

const AdditionalServicesCalculator: React.FC<Props> = ({
  formik,
  setSelectedServicesTotal
}) => {
  useEffect(() => {
    const services: IAdditionalServiceModel[] =
      formik.values.additionalServices ?? []

    const total = services
      .filter(service => service.isAdd)
      .reduce((sum, service) => {
        return sum + Number(service.totalPrice || 0)
      }, 0)

    const currentAdditionalAmount = Number(formik.values.additionalServiceAmount || 0)
    const currentServiceAmount = Number(formik.values.serviceAmount1 || 0)

    if (
      Math.abs(currentAdditionalAmount - total) > 0.01 ||
      Math.abs(currentServiceAmount - total) > 0.01
    ) {
      setSelectedServicesTotal(total)

      formik.setFieldValue(
        'additionalServiceAmount',
        Number(total.toFixed(2)),
        false
      )

      formik.setFieldValue(
        'serviceAmount1',
        Number(total.toFixed(2)),
        false
      )
    }
  }, [
    JSON.stringify(formik.values.additionalServices)
  ])

  return null
}

export default AdditionalServicesCalculator
